// @flow
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {Timeline, Alert, Table, Icon, Modal, Button, Input} from 'antd'
import CKEditor from 'react-ckeditor-component'
import { fetchTradePost } from '../../actions/trades'


class RecordsView extends Component {

    state = {
        posts: [],
        gridList: [],
        isLoading: true,
        isOpen: false,
        note: '',
        noteName: '',
        editableIndex: null
    }

    async componentWillMount() {
        const response = await fetchTradePost(this.props.tradeId)
        if (response && response.data && response.data.data && response.data.data.trades) {
            let posts = []
            if(response.data.data.trades.length) {
                posts = response.data.data.trades[0].posts
            }
            this.setState({
                posts,
                isLoading: false,
            })
        } else {
            this.setState({
                isLoading: false,
            })
        }

    }

    getColumns = () => {

        const columns = [
            {
                name: 'noteName',
                title: 'Note Name',
                dataIndex: 'noteName'
            },
            {
                name: 'note',
                title: 'Note',
                dataIndex: 'note'
            },
        ]

        if (this.props.hasWriteAccess) {
            columns.push({
                title: 'Actions',
                width: 100,
                render: (text, record, index) => (
                    <span> <Icon type="edit" className="dx-g-bs4-cursor-pointer" onClick={() => this.onEdit(index)} />
                    <Icon type="delete" className="dx-g-bs4-cursor-pointer dx-g-bs4-filter-selector-item-text" onClick={() => this.onRemove(index)} /></span>
                )
            })
        }

        return columns
    }

    onRemove = (index) => {
        let { gridList } = this.state
        gridList = gridList.filter((x, i) => i !== index)
        this.setState({
            gridList
        })
    }

    onEdit = (index) => {
        const { gridList } = this.state
        this.setState({
            note: gridList[index].note,
            noteName: gridList[index].noteName,
            editableIndex: index,
            isOpen: true
        })
    }

    onCancel = () => {
        this.setState({
            note: "",
            noteName: "",
            editableIndex: null,
            isOpen: false
        })
    }

    handleOk = () => {
        let { gridList, note, noteName, editableIndex } = this.state
        if(editableIndex === null) {
            gridList.push({note, noteName})
        } else {
            gridList[editableIndex] = {note, noteName}
        }
        this.setState({
            gridList,
            isOpen: false,
            editableIndex: null,
            note: "",
            noteName: ""
        })
    }

    onChange = (event) => {
        this.setState({
            note: event.editor.getData()
        })
    }

    render() {
        const { posts, isLoading, gridList, isOpen, note, noteName } = this.state
        return (
            <div>
                <Timeline>
                    {
                        posts.map((post, i) => (
                          <Timeline.Item key={i}><Link to={`/post/${post.slug}`}>{post.title} - {post.postDate && (post.postDate.length > 10 ? post.postDate.substr(0, 10) : post.postDate )}</Link></Timeline.Item>
                        ))
                    }
                    {
                        !isLoading && posts.length === 0 && <Alert
                            description="No Posts Found!"
                            type="info"
                        />
                    }
                </Timeline>
                <div>
                    {
                        this.props.hasWriteAccess ?
                            <div style={{textAlign: 'right', marginBottom: 10}}>
                                <Button icon="plus" onClick={() => this.setState({isOpen: true})}>New</Button>
                            </div> : null
                    }

                    <Table
                        columns={this.getColumns()}
                        size={'small'}
                        dataSource={gridList}
                        pagination={false}
                    />
                </div>
                <Modal
                    title="Add Note"
                    visible={isOpen}
                    okButtonProps={{disabled: !(noteName && note)}}
                    onOk={this.handleOk}
                    onCancel={this.onCancel}
                    style={{height: 700}}
                >
                    <div>Note Name</div>
                    <Input onChange={(e) => this.setState({noteName: e.target.value})} value={noteName}/>
                    <br/>
                    <br/>
                    <div>Note</div>
                    <CKEditor
                        activeClass="p10"
                        content={note}
                        events={{
                            change: this.onChange
                        }}
                    />
                </Modal>
            </div>
        )
    }
}

export default RecordsView


// WEBPACK FOOTER //
// ./src/components/view-trades/RecordsView.js